import { Component, AfterViewChecked, inject, input } from '@angular/core';
import { Router } from '@angular/router';

import { IBook } from '../../_models';
import { MatDialogModule } from '@angular/material/dialog';
import { BookCardComponent } from '../book-card/book-card.component';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';

@Component({
    selector: 'kbm-books-grid',
    templateUrl: './books-grid.component.html',
    styleUrls: ['./books-grid.component.scss'],
    standalone: true,
    imports: [
        MatSidenavModule,
        MatButtonModule,
        MatDialogModule,
        BookCardComponent,
    ], 
    
})
export class BooksGridComponent implements AfterViewChecked {

  books = input.required<IBook[]>();

  router = inject(Router);

  ngAfterViewChecked() {
    if (sessionStorage['currentBook'] > '') {
      this.scroll(sessionStorage['currentBook']);
    }
  }

  scroll(aBookId: string): void {
    const element = document.getElementById(aBookId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      sessionStorage.removeItem('currentBook');
    }
  }

  
  /**
   * When book clicked, save the item number so "Back" navigation can
   * use it.  Then open the item detail view of that item
   *
   * @param book
   */
  onSelect(book: IBook): void {
    sessionStorage.setItem('currentBook', book.amazon_id);
    this.router.navigate([
      '/books/',
      book.amazon_id,
      {}
    ]);
  }

}
